import axios from "axios";
import dotenv from 'dotenv';

dotenv.config();

const s = process.env.REACT_APP_API + "/api/auth/";
const API_URL = s.replace(/'/g, "");

//const API_URL = "http://xtal.asia:4051/api/auth/";
//console.log(API_URL2)
//console.log(API_URL)
class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "signin", { username, password })
      .then((response) => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        console.log(response)
        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password, chat_id) {
    console.log("axios register")
    return axios.post(API_URL + "signup", {
      username,
      email,
      password,
      roles: ['moderator', 'user'],
      chat_id
    });
/*     const options = {
      method: 'POST',
      url: 'http://xtal.asia:4016/api/auth/signup',
      headers: {'Content-Type': 'application/json', 'User-Agent': 'insomnia/9.3.3'},
      data: {
        username: 'mod4',
        email: 'mod4@mod.mod',
        password: '123456',
        roles: ['moderator', 'user'],
        chat_id: '11111'
      }
    };
    return axios.post('http://xtal.asia:4016/api/auth/signup', options.data) */

    //ok
/*     const options = {
      method: 'POST',
      url: 'http://xtal.asia:4016/api/auth/signup',
      headers: {'Content-Type': 'application/json', 'User-Agent': 'insomnia/9.3.3'},
      data: {
        username: 'mod6',
        email: 'mod6@mod.mod',
        password: '123456',
        roles: ["moderator", "user"],
        chat_id: '11111'
      }
    };
    
    axios.request(options) */
  }
}

export default new AuthService();
